module.exports = __webpack_public_path__ + "img/h9.a8597299.jpg";